<template>
  <!-- element:dialog START -->
  <el-dialog
    class="without-wrapper"
    :visible.sync="dialogVisible"
    :before-close="dialogClose"
    :fullscreen="true"
    :append-to-body="true"
    width="80%"
  >
    <span
      :class="[
        { 'screensaver-help screensaver-help-max' : type === 'manual' }
      ]"
      slot="title"
      v-if="title"
      v-html="title"></span>
    <h2
      v-if="headline"
      v-html="headline"
      :class="[
        { 'screensaver-help screensaver-help-headline-max' : type === 'manual' }
      ]"></h2>
    <div
      :class="[
        'description',
        { 'screensaver-help' : type === 'manual' }
      ]"
      v-if="description"
      v-html="description"></div>
    <div
      class="description description-static"
      v-if="!description && type === 'manual'"
    >
      <!-- manual:steps START -->
      <div class="steps">
        <!-- manual:steps:step START -->
        <div class="step step-full step-full-bug">
          <div class="text">
            <p v-html="`
              <span class='number'>1</span>
              ${$t('terminal.index.dialog.bug.step.new.first.headline')}
            `"></p>
            <ul>
              <li>{{ $t('terminal.index.dialog.bug.step.new.first.headline.first') }}</li>
            </ul>
          </div>
        </div>
        <!-- manual:steps:step END -->

        <!-- manual:steps:step START -->
        <div class="step step-full step-full-bug">
          <div class="text">
            <p v-html="`
              <span class='number'>2</span>
              ${$t('terminal.index.dialog.bug.step.new.second.headline')}
            `"></p>
            <ul>
              <li>{{ $t('terminal.index.dialog.bug.step.new.second.headline.first') }}</li>
              <li>{{ $t('terminal.index.dialog.bug.step.new.second.headline.second') }}</li>
            </ul>
          </div>
        </div>
        <!-- manual:steps:step END -->
      </div>
      <!-- manual:steps END -->

      <div
        class="close-screensaver-help"
        v-if="type === 'manual'"
        v-on:click="dialogClose"
      ></div>
    </div>
  </el-dialog>
  <!-- element:dialog END -->
</template>

<script>
export default {
  name: 'dialog-default-bug',
  props: {
    title: {
      type: String,
    },

    headline: {
      type: String,
    },

    description: {
      type: String,
    },

    dialogVisible: {
      type: Boolean,
      default: false,
    },

    dialogClose: {
      type: Function,
    },
    type: {
      type: String,
    },
  },
  data() {
    return {
      dialogVisibleChild: null,
    };
  },
  mounted() {
    this.dialogClose();
  },
};
</script>
